import React, { useState, useRef, useCallback, useEffect } from "react";

function SplitPane({ left, middle, right, defaultLeftWidth = 15, defaultRightWidth = 0, minLeft = 10, maxLeft = 30, minRight = 0, maxRight = 50 }) {
  const [leftPct, setLeftPct] = useState(defaultLeftWidth);
  const [rightPct, setRightPct] = useState(defaultRightWidth);
  const draggingRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    setRightPct((prev) => prev !== defaultRightWidth ? defaultRightWidth : prev);
  }, [defaultRightWidth]);

  const onMouseDown = useCallback((divider) => (e) => {
    e.preventDefault();
    draggingRef.current = divider;
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";

    const onMouseMove = (e) => {
      if (!draggingRef.current || !containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const pct = ((e.clientX - rect.left) / rect.width) * 100;

      if (draggingRef.current === "left") {
        setLeftPct(Math.max(minLeft, Math.min(maxLeft, pct)));
      } else {
        const fromRight = 100 - pct;
        setRightPct(Math.max(minRight, Math.min(maxRight, fromRight)));
      }
    };

    const onMouseUp = () => {
      draggingRef.current = null;
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  }, [minLeft, maxLeft, minRight, maxRight]);

  const showRight = rightPct > 0 && right;

  return (
    <div className="split-pane" ref={containerRef}>
      <div className="split-left" style={{ width: `${leftPct}%` }}>
        {left}
      </div>
      <div className="split-divider" onMouseDown={onMouseDown("left")}>
        <div className="divider-grip" />
      </div>
      <div className="split-middle" style={{ width: showRight ? `${100 - leftPct - rightPct}%` : `${100 - leftPct}%` }}>
        {middle}
      </div>
      {showRight && (
        <>
          <div className="split-divider" onMouseDown={onMouseDown("right")}>
            <div className="divider-grip" />
          </div>
          <div className="split-right" style={{ width: `${rightPct}%` }}>
            {right}
          </div>
        </>
      )}
    </div>
  );
}

export default SplitPane;
